let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("71aNb")).then(() => parcelRequire('dNzo7'));